import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import TrainingReportTable from './components/TrainingReportTable';
import useTrainingReportsData from './hooks/useTrainingReportsData';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useLmsPermission } from '../hooks/useLmsPermission';
import { LMS } from '../../../constants/permissionCodes';

/**
 * Eğitim Raporları ana sayfası — liste. Ekleme/düzenleme artık modal değil, ayrı bir sayfa
 * (`createEditForm/TrainingReportCreateEdit.jsx`, route: `training-report/create` ve
 * `training-report/:id`) — `TrainingCatalogPage`/`TrainingCatalogCreateEdit.jsx` ile aynı desen.
 * `my-trainings/index.jsx`'teki "Eğitim Planlama İşlemleri" kartında, önceden bağlı bir sayfası
 * olmayan yer tutucu satırın yerine "Eğitim Raporu" olarak buraya bağlanıyor.
 * Bkz. docs/LMS-Egitim-Raporlari-API.md.
 */
const TrainingReportPage = () => {
    const { th } = useLanguage();
    const { can } = useLmsPermission();
    const navigate = useNavigate();
    const { reportsApi, isLoading } = useTrainingReportsData();

    const reports = reportsApi?.items || [];

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('trainingReport.pageTitle')}</h1>
                {can(LMS.REPORT_CREATE) && <Button label={th('trainingReport.addButton')} icon="pi pi-plus" onClick={() => navigate('/learning-management-system/training-report/create')} />}
            </div>

            <TrainingReportTable reports={reports} loading={isLoading} />
        </div>
    );
};

export default TrainingReportPage;
